import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mission-vission',
  templateUrl: './mission-vission.component.html',
  styleUrls: ['./mission-vission.component.scss']
})
export class MissionVissionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
